module.exports = __webpack_public_path__ + "img/Review_text04_beliefs.7e5b4aec.png";